import type { Instance, Project, Workspace } from "@/server/types";

// Single source of truth for connection status lives in the instance module
export { DISCONNECT_THRESHOLD } from "@/modules/instance/types";
export { isConnected, getStatusColor } from "@/modules/instance/utils";

export interface WorkspaceGroup {
  workspace: Workspace;
  instances: Instance[];
  activeInstances: Instance[];
  hasRunning: boolean;
  hasConnected: boolean;
  isDone: boolean;
  latestActivity: number | null;
  latestSeen: number;
}

export interface ProjectGroup {
  project: Project | null;       // null for unassigned instances
  workspace: Workspace | null;   // workspace for this group (if workspace-based)
  groupKey: string;              // project.id, workspace.id, or hostPath/workingDir fallback
  displayName: string;
  instances: Instance[];
  recentInstances: Instance[];
  archivedInstances: Instance[];
  workspaceGroups: WorkspaceGroup[];
  unassignedInstances: Instance[];
  hasRunning: boolean;
  hasConnected: boolean;
  latestSeen: number;
  latestActivity: number | null;
}

export const truncate = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength - 1) + "…";
};

export const getProjectDisplayName = (workingDir: string | null, fallbackName: string): string => {
  if (!workingDir) return fallbackName;
  const segments = workingDir.split("/").filter(Boolean);
  return segments[segments.length - 1] || fallbackName;
};

export const isUnread = (instance: Instance): boolean => {
  if (!instance.lastActivity) return false;
  if (!instance.lastViewedAt) return true;
  return instance.lastActivity > instance.lastViewedAt;
};
